import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-10 pb-10 md:pt-14 md:pb-16 px-4 md:px-8 max-w-6xl mx-auto overflow-hidden" data-id="element-51">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl bg-accent/5 blur-[120px] -z-10 rounded-full pointer-events-none" data-id="element-52" />

      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="flex-1 text-center lg:text-left" data-id="element-54">
          <div className="inline-block border border-accent/30 bg-accent/10 text-accent font-oswald tracking-widest uppercase px-3 py-1 text-sm mb-6" data-id="element-55">
            Sistema Operativo Biológico
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-[1.1] mb-6 uppercase" data-id="element-56">
            Maquinaria de Enfoque:{' '}
            <span className="text-accent" data-id="element-57">Fin de la Distracción</span>
          </h1>
          <p className="text-xl md:text-2xl text-zinc-300 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-58">
            El sistema operativo biológico para facturar sin interrupciones y
            aniquilar tus pendientes en bloques de 180 minutos.
          </p>
          <CTAButton className="w-full sm:w-auto" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-59">
            Elimina tus pendientes ahora
          </CTAButton>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 50,
        rotate: -5
      }} animate={{
        opacity: 1,
        y: 0,
        rotate: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex-1 relative w-full max-w-md lg:max-w-full" data-id="element-60">
          <div className="absolute inset-0 bg-gradient-to-tr from-accent/20 to-transparent blur-2xl -z-10" data-id="element-61" />
          <img src="https://cdn.magicpatterns.com/uploads/kjMuXCz7hEaCPH7gGQL9Fx/Maquinaria-de-Enfoque.png" alt="Maquinaria de Enfoque en un iPad" className="w-full h-auto object-cover rounded-lg shadow-2xl border border-tactical-border" data-id="element-62" />
        </motion.div>
      </div>
    </section>;
}